import { render, staticRenderFns } from "./quantityManage.vue?vue&type=template&id=2a38c2ce&scoped=true"
import script from "./quantityManage.vue?vue&type=script&lang=js"
export * from "./quantityManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38c2ce",
  null
  
)

export default component.exports